export GenericPersistence from "./generic.persistence";



// WEBPACK FOOTER //
// ./src/core/data/persistence/index.js